import React from 'react';

export const Header: React.FC = () => {
  const scrollToId = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-50 px-6 py-6 md:px-12 flex justify-between items-center bg-transparent">
      <div className="text-lg font-serif font-bold tracking-tight text-primary">
        LeadFraud.org
      </div>
      <button 
        onClick={() => scrollToId('why')}
        className="text-sm font-medium text-secondary hover:text-primary transition-colors border-b border-transparent hover:border-gray-400 pb-0.5"
      >
        Why this project?
      </button>
    </header>
  );
};